import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import OpenQuestion from './OpenQuestion'

const SingleChoiceOptions = (props) => {
	//bool
	const { isSaving, canBeAddedResponse } = props
	const { question, checklistResponse } = props
	//Functions
	const { onChecklistResponse } = props

	let existResponseQuestionResponse = checklistResponse && checklistResponse.QuestionResponses.find((x) => x.Question.Token === question.Token)
	return (
		<RadioGroup>
			{question.Options.map((option, optionIndex) => {
				let existResponse =
					existResponseQuestionResponse &&
					existResponseQuestionResponse.SelectedOptions &&
					existResponseQuestionResponse.SelectedOptions.find((x) => x.Token === option.Token)
				return (
					<>
						<div
							key={optionIndex}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								marginBottom: '2px',
								paddingLeft: '8px', // Espaciado interno opcional
								paddingRight: '8px', // Espaciado interno opcional
								borderRadius: '4px' // Bordes redondeados opcionales
							}}
						>
							<FormControlLabel
								style={{ '& .MuiTypography-root': { fontSize: '12px' } }}
								value={option.Title}
								control={
									<Radio
										color='primary'
										checked={existResponse ? true : false}
										disabled={!canBeAddedResponse || isSaving}
										// style={{paddingTop:5}}
									/>
								}
								label={option.Title}
								onClick={(event) => onChecklistResponse(question.Token, '', option.Token)}
								disabled={!canBeAddedResponse || isSaving}
							/>
						</div>

						{option.RequiresOpenAnswer && existResponse && (
							<OpenQuestion
								onChecklistResponse={(questionToken, answer) => onChecklistResponse(questionToken, answer, option.Token)}
								//objects
								checklistResponse={checklistResponse}
								question={question}
								// bool props
								canBeAddedResponse={canBeAddedResponse}
								isSaving={isSaving}
							/>
						)}
					</>
				)
			})}
		</RadioGroup>
	)
}

SingleChoiceOptions.propTypes = {
	serie: PropTypes.shape({
		Serie: PropTypes.string,
		Model: PropTypes.string
	}),
	onSave: PropTypes.func.isRequired
}

export default SingleChoiceOptions
